<p>Folder Name:</p><input (input)="onFileName(fileName.value)" #fileName>
